import { formatDate } from "../utils/utils";
import UserAvatar from "../components/global/avtar/UserAvatar";
import Delete from "../assets/Delete";
import { useUserStore } from "../store/userStore";

const defaultRender = (value) => (value ? value : "--");

const useColumns = (onDelete) => {
  const userDetails = useUserStore((state) => state.userDetails);
  const isAdmin = userDetails?.roleName?.toLowerCase() === "admin";

  const columns = [
    {
      title: "User",
      dataIndex: "name",
      render: (_, record) => (
        <UserAvatar
          data={{
            name: record?.name,
            email: record?.email,
          }}
        />
      ),
    },
    {
      title: "Mobile No",
      dataIndex: "phoneNo",
      render: (value) =>
        isAdmin
          ? defaultRender(value)
          : value
            ? (
                <a
                  href={`tel:${value}`}
                  onClick={(e) => e.stopPropagation()}
                  className="hover:underline"
                >
                  {value}
                </a>
              )
            : "--",
    },
    {
      title: "Country",
      dataIndex: "countryName",
      render: defaultRender,
    },
    {
      title: "Sales",
      dataIndex: "salesName",
      render: defaultRender,
    },
    {
      title: "User Type",
      dataIndex: "userType",
      render: defaultRender,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      render: (value) => (value ? formatDate(value) : "--"),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <button type="button" onClick={() => onDelete && onDelete(record)}>
          <Delete />
        </button>
      ),
    },
  ];

  return columns;
};

export default useColumns;
